<div *ngIf="this.userService.user | async as user; else loadingOrError" class="wrapper">
  <mat-card class="card">
    <mat-card-content>
      <mat-grid-list cols="3" class="avatar">
        <mat-grid-tile colspan="1">
          <img class="image" src="assets/default-user-female.svg" />
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <div class="info">
            <div class="name">{{user.first_name}} {{user.last_name}}&nbsp;<small>({{user.username}})</small></div>
              <div class="email">{{user.email}}</div>
          </div>
           <app-credit-display></app-credit-display>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-card-content>
  </mat-card>
  <!--
  <mat-card class="card notification-panel" matBadge="3" matBadgeSize="large" matBadgePosition="before" matBadgeColor="warn">
    <mat-card-content>
      <h1>Notifications</h1>

      <mat-accordion>
        <app-notification [status]="'succeeded'"></app-notification>
        <app-notification [status]="'succeeded'"></app-notification>
        <app-notification [status]="'succeeded'"></app-notification>
      </mat-accordion>
      
    </mat-card-content>
  </mat-card>
  -->
</div>

<ng-template #loadingOrError>
    <span>Loading quota or no data available...</span>
</ng-template>